import fbUrl from "~/assets/js/FB.js?url";

const _initFacebook = (): Promise<string> => {
  return new Promise((reslove, reject) => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: import.meta.env.VITE_FACEBOOK_APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: "v17.0",
        status: true,
      });

      reslove("init facebook success");
    };
    loadJSWidthUrl(fbUrl).catch((err) => {
      reject(err);
      window.initFacebook = null;
    });
  });
};

export const initFacebookInit = () => {
  if (window.initFacebook) return window.initFacebook;
  window.initFacebook = _initFacebook();
  return window.initFacebook;
};
